import {API, Get, makeSearchParams} from "./index";

let vehiclesController;

const GetVehicles = (lat, lng, search) => {
    if (vehiclesController) {
        vehiclesController.abort("deduplication")
    }

    vehiclesController = new AbortController();
    return Get("vehicles", {
        ...lat ? {lat} : {},
        ...lng ? {lng} : {},
        ...search ? {search} : {},
    }, vehiclesController.signal)
}

let vehicleOfferController;

const GetVehicleOffer = (id) => {
    if (vehicleOfferController) {
        vehicleOfferController.abort("deduplication")
    }
    vehicleOfferController = new AbortController();
    return Get("vehicles/" + id + "/offer", null, vehicleOfferController.signal)
}

export {GetVehicles, GetVehicleOffer}